// Field names returned by the /orders2 endpoint
export const CM_PRODUCT_SWD = "product^swd";
export const CM_PRODUCT_CLIENT_NAME = "product^salesDescr2";
export const CM_PRODUCT_DESCR = "product^descr";
export const CM_QTY = "unitQty";
export const CM_UNIT = "tradeUnit";
export const CM_ORDER_DATE = "startDateWeekOrDay";
export const CM_DELIVERY_DATE = "deadlineWeekOrDay";
export const CM_DELIVERY_PERIOD = "serviceDateWeekOrDay";
export const CM_ERLIEST_DELIVERY_DATE = "deadlineEarliestWeekOrDay";

// Date formats (date-fns tokens)
export const DF_ABAS_DATE = "yyyyMMdd";
export const DF_PL_DATE = "dd.MM.yyyy";

// API
export const MATERIALS_ENDPOINT = "https://node.zeitrec.com/api/orders2";
export const MATERIALS_REFRESH_INTERVAL = 15 * 60 * 1000;
export const MATERIALS_RETRY_DELAY = 4000;
export const MATERIALS_MAX_RETRIES = 3;

export const EMPTY_VALUE = "-";
